export default {
      id: "oc-ecloud-usage",
      viewBox: "0 0 1351 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-ecloud",
      toString: function () {
        return this.url;
      }
    }